import { createClient } from "@libsql/client/web"; // web variant
import { config } from "dotenv";
import { drizzle } from "drizzle-orm/libsql";
import * as schema from "./schema";

// Load environment variables
config({ path: ".env" });

// Validate environment variables
if (!process.env.TURSO_CONNECTION_URL) {
	throw new Error("TURSO_CONNECTION_URL environment variable is required");
}

if (!process.env.TURSO_AUTH_TOKEN) {
	throw new Error("TURSO_AUTH_TOKEN environment variable is required");
}

const client = createClient({
	url: process.env.TURSO_CONNECTION_URL,
	authToken: process.env.TURSO_AUTH_TOKEN,
});

export const db = drizzle({ client, schema });
// Re-export schema for convenience
export * from "./schema";
